module.exports = __webpack_public_path__ + "img/WTMS_sword4.54f3afdc.png";